import React from "react";
import Frame from "../shell/Frame";
import Meta from "../shell/Meta";
import WorkGrid from "../parts/WorkGrid";
import Invite from "../parts/Invite";

const Work = () => (
  <Frame>
    <Meta title="Selected work" description="A representative sample of recent BTCRuka engagements — anonymised under NDA." />

    <section className="svc-hero">
      <div className="shell">
        <div className="crumb">~ <span className="sep">/</span> work</div>
        <span className="eyebrow">Selected work · Under NDA</span>
        <h1>Recent engagements.</h1>
        <p className="lede">
          Every client engagement is bound by confidentiality. The cases below are anonymised but technically accurate —
          they describe the actual shape, sector and disciplines of the work.
        </p>
      </div>
    </section>

    <section className="band">
      <div className="shell">
        <WorkGrid />
      </div>
    </section>

    <Invite
      eyebrow="Your engagement"
      title="What does yours look like?"
      text="Tell us the rough shape of what you are trying to change. We respond within one business day with a candid view of fit."
    />
  </Frame>
);

export default Work;
